import { render, staticRenderFns } from "./DepositRecords.vue?vue&type=template&id=edf074b2&scoped=true&"
import script from "./DepositRecords.vue?vue&type=script&lang=js&"
export * from "./DepositRecords.vue?vue&type=script&lang=js&"
import style0 from "./DepositRecords.vue?vue&type=style&index=0&id=edf074b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf074b2",
  null
  
)

export default component.exports